import { ManageApplicationsService } from './manage-applications.service';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-manage-applications',
  templateUrl: './manage-applications.component.html',
  styleUrls: ['./manage-applications.component.css']
})
export class ManageApplicationsComponent implements OnInit {

  applications
  currentDate = new Date();
  vacancyStatus

  constructor(private manageApplicationsService:ManageApplicationsService) { }

  ngOnInit(): void {
    this.getApplications();
    this.currentDate;
  }

  compareDates(date1){
    if(date1 > formatDate(new Date(), 'yyyy-MM-dd', 'en'))
      this.vacancyStatus = true;     
    else
      this.vacancyStatus = false;      
    return this.vacancyStatus
  }

  getApplications(){
    this.manageApplicationsService.getApplications()
    .subscribe( response => {
      this.applications = response
      console.log("========================== APLLICTIONS ",response)
    })
  }

  deleteApplication(id: number){
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to restore this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, withdraw!',
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {
        console.warn("=============== id ::: ",id)
        this.manageApplicationsService.deleteApplication(id)
        .subscribe(response => {
          Swal.fire(
            'Withdrawn!',
            'Application has been withdrawn.',
            'success'
            );
            this.getApplications();
        })
      }
    });
    
  }

}
